import { setupPsiConfig, setupPsiConfigAsync } from './psi.js';
import { setupSccApi } from './scc.js';
import { setupTcfApi } from './tcf.js';
import { version } from './version.js';
import {
    loadMessagingScript,
    loadExternalToolsScript,
    loadTcfApi,
    dispatchCmpInitEvent,
    checkAdChoicesAccess,
    postRejectAll,
} from './utils/index.js';
import { checkIfShouldDisableOnWebview } from './utils/mobile.js';

export function psi(window, document, navigator, config) {
    loadExternalToolsScript(document, config);
    setupPsiConfig(window, document, navigator, { ...config, jsSdkVersion: version }, 'psi');
    loadMessagingScript(config, document);
    dispatchCmpInitEvent();
}

export function scc(window, document, navigator, config) {
    loadExternalToolsScript(document, config);
    setupPsiConfig(window, document, navigator, config, 'scc');
    setupSccApi(window, config);
    loadMessagingScript(config, document);
    dispatchCmpInitEvent();
}

export async function tcf(window, document, navigator, config) {
    // workaround for webviews. do not init sourcepoint if native consent is not passed
    if (checkIfShouldDisableOnWebview(window, navigator, config)) {
        console.warn('CMP: Native consent is not passed. Sourcepoint will not be initialized.');
        return;
    }

    loadTcfApi(document);
    loadExternalToolsScript(document, config);

    setupTcfApi(window, config);

    // Deprecated: enableEcosystemConsent is no longer supported
    if (config.enableEcosystemConsent) {
        console.warn('@schibsted/sourcepoint: enableEcosystemConsent is deprecated and no longer supported. This feature has been removed. Please remove this config option.');
    }

    if (config.enableAdChoicesFeature) {
        const adChoicesAccessible = await checkAdChoicesAccess(window, config);
        if (adChoicesAccessible) {
            postRejectAll(window);
        }
    }

    if (config.enableUserCentric || config.enableAdChoicesFeature) {
        await setupPsiConfigAsync(window, document, navigator, config, 'tcf');
    } else {
        setupPsiConfig(window, document, navigator, config, 'tcf');
    }

    loadMessagingScript(config, document);
    dispatchCmpInitEvent();
}
